import { render } from "./draggableQuestions.vue?vue&type=template&id=7e28d056&scoped=true"
import script from "./draggableQuestions.vue?vue&type=script&lang=js"
export * from "./draggableQuestions.vue?vue&type=script&lang=js"

import "./draggableQuestions.vue?vue&type=style&index=0&id=7e28d056&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e28d056"]])

export default __exports__